module.exports = __webpack_public_path__ + "system/img/upgrade.c636f6a6.png";